export class CustomPropertyValidators {
  static isAtLeastThreeCharactersLong = {
    message: 'Must be at least 3 characters long!',
    isValid: (value) => {
      return typeof value === 'string' && value.length >= 3;
    },
  };
  static isNotEmpty = {
    message: 'Must not be empty!',
    isValid: (value) => {
      return value !== null && value !== undefined && value !== '';
    },
  };
}
